// Version configuration for APL Ubil+
const getEnvironment = () => {
  // Check for explicit environment variables first
  if (process.env.REACT_APP_ENV) {
    return process.env.REACT_APP_ENV;
  }
  
  // Detect environment based on API URL (most reliable)
  const apiUrl = process.env.REACT_APP_API_URL || '';
  
  // Production API URL pattern
  if (apiUrl === 'https://gateway.api.ubil-apl.com/api') {
    return 'production';
  }
  
  // QA/Staging API URL patterns
  if (apiUrl.includes('qa') || apiUrl.includes('staging') || apiUrl.includes('test')) {
    return 'qa';
  }
  
  // Check hostname for QA patterns
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    if (hostname.includes('qa') || hostname.includes('staging') || hostname.includes('test')) {
      return 'qa';
    }
    if (hostname.includes('localhost') || hostname.includes('127.0.0.1')) {
      return 'development';
    }
    // If it's a production domain but not the production API, might be QA
    if (hostname.includes('ubil-apl') || hostname.includes('apl')) {
      return apiUrl.includes('localhost') ? 'development' : 'qa';
    }
  }
  
  // Fall back to NODE_ENV
  const nodeEnv = process.env.NODE_ENV || 'development';
  
  // Handle common environment mappings
  if (nodeEnv === 'production') return 'production';
  if (nodeEnv === 'qa' || nodeEnv === 'staging') return 'qa';
  if (nodeEnv === 'test') return 'test';
  
  return 'development';
};

export const APP_VERSION = {
  version: '3.3.0',
  buildDate: '2026-10-28',
  buildNumber: '2026.10.28.2014',
  environment: getEnvironment(),
  appName: 'APL Ubil+',
  appCode: 'APL-UBIL-PLUS'
};

// Get version from package.json for development
export const getPackageVersion = () => {
  try {
    // In development, we can't access package.json directly, so we'll use the hardcoded version
    // In production, this could be injected during build
    return APP_VERSION.version;
  } catch (error) {
    return APP_VERSION.version;
  }
};

// Get full version string
export const getFullVersion = () => {
  const version = getPackageVersion();
  const env = APP_VERSION.environment;
  return `${version} (${env})`;
};

// Debug function to help troubleshoot environment detection
export const getEnvironmentDebugInfo = () => {
  const apiUrl = process.env.REACT_APP_API_URL || '';
  const nodeEnv = process.env.NODE_ENV || 'development';
  const reactAppEnv = process.env.REACT_APP_ENV;
  let hostname = 'N/A';
  
  if (typeof window !== 'undefined') {
    hostname = window.location.hostname;
  }
  
  return {
    apiUrl,
    nodeEnv,
    reactAppEnv,
    hostname,
    detectedEnvironment: getEnvironment()
  };
};

// Get build info
export const getBuildInfo = () => {
  return {
    version: APP_VERSION.version,
    buildDate: APP_VERSION.buildDate,
    buildNumber: APP_VERSION.buildNumber,
    environment: APP_VERSION.environment
  };
};

export default APP_VERSION;


